module.exports = __webpack_public_path__ + "static/media/msteams-logo-2.980cf206.svg";